import $ from 'jquery';
$(document).on('show.bs.modal', '.modal', function(event) {
  var zIndex = 1040 + (10 * $('.modal:visible').length);
  $(event.target).css('z-index', zIndex);
  setTimeout(function() {
    $('.modal-backdrop')
      .not('.modal-stack')
      .css('z-index', zIndex - 1)
      .addClass('modal-stack');
  }, 0);
}).on('shown.bs.modal', '.modal:not(.modal-fast-buy)', function(event) {
  event.target.querySelector('input') && event.target.querySelector('input').focus();
}).on('hidden.bs.modal', '.modal', function(event) {
  var modalVisible = $('.modal-backdrop');
  if (modalVisible.length) {
    $(document.body).css('padding-right', '0px');
    $(document.body).addClass('modal-open');
  }
});
